<template>
  <HeadlineComponent>Angekommen / Abwesend</HeadlineComponent>
  <div class="row">
    <div class="col-sm-6">
      <h2>Angekommen</h2>
      <div>
        <div v-for="t of arrivedTickets" :key="t.id">{{t.user.full_name}}</div>
      </div>
    </div>
    <div class="col-sm-6">
      <h2>Nicht da</h2>
      <div>
        <div v-for="t of notArrivedTickets" :key="t.id">{{t.user.full_name}}</div>
      </div>
    </div>
  </div>

</template>

<script>
import {mapActions} from "pinia";
import {useAlertsStore} from "@/stores/alerts.js";
import ticketService from "@/services/ticket.service.js";
import HeadlineComponent from "@/components/HeadlineComponent.vue";
import * as Sentry from '@sentry/vue';

export default {
    name: "UsersArrivedView",
    data() {
        return {
            tickets: []
        };
    },
    methods: {
        ...mapActions(useAlertsStore, { addAlert: "add" })
    },
    computed: {
        arrivedTickets() {
            return this.tickets.slice().filter(t => t.user && !!t.user.id && t.has_arrived);
        },
        notArrivedTickets() {
            return this.tickets.slice().filter(t => t.user && !!t.user.id && !t.has_arrived);
        }
    },
    async beforeRouteEnter(to, from, next) {
        let tickets = [];
        try {
            let response = await ticketService.index();
            tickets = response.data;
        }
        catch (e) {
          if (e) {
                Sentry.captureException(e);
                useAlertsStore().add("danger", "Es ist was unerwartetes schief gegangen..");
                window.scrollTo(0, 0);
            }
        }
        next(vm => { vm.tickets = tickets; });
    },
    components: { HeadlineComponent }
}
</script>

<style scoped>

</style>